<script>
//TODO: centralize location, time and canteen settings!
import Modal from '@/components/atoms/Modal'
import Step0 from '@/components/organism/location/addLocation/Step0'
import Step1 from '@/components/organism/location/addLocation/Step1'
import Step2 from '@/components/organism/location/addLocation/Step2'
import Step3 from '@/components/organism/location/addLocation/Step3'
import ButtonLoader from '@/components/atoms/ButtonLoader'
import { Query } from '@/modules/plugins/query'
import slideTransitions from '@/modules/mixins/slideTransitions'

import { mapGetters } from 'vuex'
import { Address } from '@/api'

const FIRST_STEP = 0
const HAS_LOCATION_FIRST_STEP = 1
const USER_FINAL_STEP = 3
const GUEST_FINAL_STEP = 2

export default {
    name: 'ModalAddLocation',

    components: {
        Modal,
        Step0,
        Step1,
        Step2,
        Step3,
        ButtonLoader,
    },

    mixins: [slideTransitions],

    data() {
        return {
            address: {},
            step: null,
            callback: null,
            firstStep: null,
            loading: false,
            canSearchForNew: false,
            updateAddress: false,
            closable: true,
        }
    },
    computed: {
        ...mapGetters({
            needToSetQuery: 'site/needToSetQuery',
            orderAddress: 'order/address',
            orderRestaurant: 'order/restaurant',
        }),
        isLoggedIn() {
            return this.$user?.isLoggedIn
        },
        finalStep() {
            return this.isLoggedIn ? USER_FINAL_STEP : GUEST_FINAL_STEP
        },
        title() {
            switch (this.step) {
                case 0:
                    return this.$t('details.search_address')
                case 1:
                    return this.$t('details.confirm_address')
                case 2:
                    return this.$t('details.specify_address')
                case 3:
                    return this.$t('details.comment_address')
                default:
                    return this.$t('details.search_address')
            }
        },
        label() {
            switch (this.step) {
                case 1:
                    return this.$t('labels.select_address')
                default:
                    return null
            }
        },
        buttonLabel() {
            switch (this.step) {
                case 0:
                    return this.$t('details.search_address_btn')
                case 1:
                    return this.$t('details.confirm_address_btn')
                case 2:
                    return this.$t('details.specify_address_btn')
                case 3:
                    return this.$t('details.comment_address_btn')
                default:
                    return this.$t('details.search_address_btn')
            }
        },
        addressModel: {
            get() {
                return this.address.model
            },
            set(model) {
                this.address.model = model
            },
        },
        scrollId() {
            return `addLocation-${this._uid}`
        },
    },
    methods: {
        open(location, callback, updateAddress = false, closable = true) {
            this.closable = closable
            this.canSearchForNew = location
            this.updateAddress = updateAddress
            this.firstStep = location ? HAS_LOCATION_FIRST_STEP : FIRST_STEP
            this.step = this.firstStep
            this.callback = callback
            this.address = new Address(location)
            if (this.isLoggedIn) this.address.model.phone = this.$user.model.phone
            this.$refs.ModalLocation.openModal()
        },
        close() {
            this.$refs.ModalLocation.closeModal()
        },
        async nextStep() {
            await this.setSlideLeft()
            if (this.step < this.finalStep) this.step++
            else if (this.step === this.finalStep) {
                if (this.isLoggedIn) this.save()
                else this.setAddress()
            }
        },
        verifyStep() {
            if (this.$refs[`step-${this.step}`].verifyStep)
                this.$refs[`step-${this.step}`].verifyStep()
        },
        async save() {
            try {
                this.loading = true
                const result = await this.address.save()
                this.address.updateModel(result)
                if (this.updateAddress) await this.setAddress()
                else if (this.callback) this.callback()
                if (this.$route.name === 'checkout')
                    this.$filteredAddresses.fetch(this.orderRestaurant.id)

                this.close()
                await this.$addresses.fetch()
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(e)
            } finally {
                this.loading = false
            }
        },
        async setAddress() {
            this.$location.select.set(this.address.model, false)
            this.$user.getExpenseRules()
            if (this.$route.name === 'checkout') {
                this.$cart.setInvoice()
                this.$cart.setPhone(this.$user.model, this.orderAddress)
            }
            if (this.needToSetQuery) {
                this.setQuery(Query.getLocationQuery(this.address.model))
            }

            try {
                await this.$cart.calculate()
            } finally {
                if (this.callback) this.callback()
                this.close()
            }
            return
        },
        async back(searchForNew = false) {
            await this.setSlideRight()
            if (this.canSearchForNew && searchForNew) {
                this.firstStep = FIRST_STEP
                this.step = FIRST_STEP
                this.address.reset()
                this.canSearchForNew = false
            } else if (this.step <= this.finalStep && this.step > 0) this.step--
        },
    },
}
</script>

<template lang="pug">
modal.add-location(ref="ModalLocation" :scroll-id="scrollId"  :closable="step === firstStep && closable" close-class="btn-white-primary top-fix-8 top-md-fix-16 transform-none" scroll)
    template(v-slot:header)
        transition(name="fade")
            button.btn.btn-white-primary.btn-icon.rounded-circle.position-absolute(@click="back(false)" v-if="step !== firstStep")
                icon(icon="fa-solid fa-arrow-left" size="lg")
        transition(:name="slide")
            .step-indicator(v-if="step")
                span(v-for="index in finalStep" :class="{'fill-step': index <= step}")
        transition(:name="slide" mode="out-in")
            .modal-header-text.text-center.pt-8(:key="`step-title-${step}`") {{ title }}
                template(v-if="label")
                    br
                    span {{ label }}
    template(v-slot:body)
        transition(:name="slideAbsolute" mode="out-in")
            component(:is="`step-${step}`" v-model="addressModel" @next="nextStep" :loading.sync="loading" :scroll-id="scrollId" :ref="`step-${step}`" :key="`step-${step}`")            
    template(v-slot:footer)
        transition(:name="slide")
            .p-5.w-100.d-flex(v-if="step")
                button.btn.btn-white-primary.btn-block(v-if="canSearchForNew" @click="back(true)" :class="{'mr-2': canSearchForNew}") {{ $t('details.search_address') }}
                button-loader.btn.btn-primary.btn-block.mt-0(@click="verifyStep" :class="{'ml-2': canSearchForNew}" :loading="loading")
                    transition(name="fade" mode="out-in")
                        span(:key="`step-label-${step}`") {{ buttonLabel }}
       
</template>
